<!--景点详情 view:18-->
<template>
    <div class="View17Wrapper shadowRadius">
        <Swiper v-if="list.carouse.length > 0" interval="4000" duration="500" :autoPlay='true'>
            <Slide v-for="(item,ix) in list.carouse" :key="`swiper-v-17-${ix}`">
                <img :src="item.imgUrl" :alt="item.name">
            </Slide>
        </Swiper>
        <div class="contentWrapper">
           <div>
               <div class="nameStar"><div class="name">{{list.details.name||'地名'}}</div></div>
               <div class="starBox"><div v-for="(it,ix) in createArray(list.details.star>5?5:list.details.star)" :key="`it-${ix}`" class="arrayBox"><img :src="require(`../../assets/img/${it.star}.png`)" alt="" class="starImg"></div></div>
           </div>
            <div class="tagsBox">
                <SelectTags button-type="tour" :list="list.details.tags"/>
            </div>
            <div class="baseInfo">
              <div class="baseSpace">
                  <div class="base">
                      <img src="../../assets/img/position.png" alt="" class="baseImg">
                      <div class="baseText basePoWidth">地址：{{list.baseInfo.area.name}}</div>
                  </div>
                  <Pointer text="导航" @on-click="()=>onToast('导航功能',list.baseInfo.area.toastType,list.baseInfo.area.children)"/>
              </div>
                <div class="base">
                    <img src="../../assets/img/time.png" alt="" class="baseImg">
                    <div class="baseText">用时参考：{{list.baseInfo.time.name||'暂无'}}</div>
                </div>
                <div class="base">
                    <img src="../../assets/img/phone.png" alt="" class="baseImg">
                    <div class="baseText">电话：{{list.baseInfo.phone.name||'暂无'}}</div>
                </div>

                    <div class="base">
                    <img src="../../assets/img/introduce.png" alt="" class="baseImg">
                      <div class="baseColumn">
                          <div class="baseText overFourLine">{{list.baseInfo.introduce.name}}</div>
                          <Pointer text="查看详情"  @on-click="()=>onToast(list.details.name,list.baseInfo.introduce.toastType,list.baseInfo.introduce.name)"/>
                      </div>

                    </div>

            </div>
            <div class="moreListBox">
                <ScenicSpot :list="list.relateInfo" @on-select="onSelect"/>
            </div>
        </div>
    </div>
</template>
<script>
    import { Swiper, Slide } from 'vue-swiper-component';
    import {createArray} from '@/utils/utils'
    import Pointer from '../Use/pointer'
    import ScenicSpot from '../Use/scenic-spot'
    import SelectTags from '../Use/tags'
    import {mapMutations} from "vuex";
    export default {
        name: "View17",
        components: {
            Swiper,
            Slide,
            Pointer,
            ScenicSpot,
            SelectTags
        },
        props: {
            list: {
                type: Object,
                default:()=>{}
            },
            tips: {
                type: String,
                default: ""
            }
        },
        data() {
            return {


            };

        },
        mounted() {

        },
        methods: {
            ...mapMutations([
                "setToastContent","setToastShow"
            ]),
            onAsk(name,value) {
                this.$emit('on-ask',name,value)
            },
            createArray(n){
                return createArray(n,1)
            },
            onToast(name,toastType,children){
                if(name=='导航功能'){
                    cio.track(5,'click', "guide_click");
                }

                this.setToastShow(true)
                this.setToastContent({toastType,list:{name:name,content:children}})
            },
            onSelect(name,value,id,toastType,children){
                console.info('children',toastType,children)
                this.setToastShow(true)
                this.setToastContent({toastType,list:{name:name,content:children}})
            },
        }
    };
</script>
<style lang="less" scoped>

    .View17Wrapper {
    background: #fff;
        width: 9.2rem;
   .contentWrapper{
       line-height: .6rem;
       margin: .3rem .3rem;
       min-height: 1.5rem;
       background: #fff;

       overflow:hidden;
       .nameStar{
           display: flex;
           justify-content: space-between;
           align-items: center;
           .name{
               color:rgba(23,30,50,1);
               font-size: .44rem;
           }
           .distance{
               color:rgba(100,103,114,1);
               font-size: .38rem;
           }

       }

       .area{
           color:rgba(100,103,114,1);
           font-size: .38rem;
           overflow: hidden;
           white-space: nowrap;
           text-overflow: ellipsis;
           margin-top: .3rem;
       }

       .baseInfo{
           padding: .2rem 0;
           border-bottom: .02rem solid #EAF1F9;
           .baseSpace{
               display: flex;
               justify-content: space-between;
               align-items: center;
           }
           .base{
               padding: .1rem 0;
               display: flex;
               justify-content: flex-start;
              .column{

              }
               .baseImg{
                   width: .5rem;
                   height: .5rem;
                   margin-right: .15rem;
                   vertical-align: bottom;
               }
               .baseText{
                   color: #646772;
                   font-size: .40rem;
                   line-height: .6rem;
               }
               .basePoWidth{
                   width: 6.5rem;
                   text-overflow :ellipsis;
                   white-space :nowrap;
                   overflow : hidden;
               }
               .overFourLine{
                   overflow: hidden;
                   text-overflow: ellipsis;
                   display: -webkit-box;
                   -webkit-line-clamp: 4;
                   -webkit-box-orient: vertical;
                   max-width: 7.8rem;

               }

           }
       }
       .moreListBox{
           padding: .25rem 0;

       }
   }
    }

</style>
